import { CKEditorProps, useCKEditor } from 'ckeditor4-react';
import { FunctionComponent, useEffect, useState } from 'react';
import InputFieldWrapper, { BaseInputProps } from '../inputs/inputFieldWrapper';
type EditorProps = CKEditorProps<any>['props'];
type Props = BaseInputProps & Omit<EditorProps, 'editor' | 'data'>;

export const TextEditor: FunctionComponent<Props> = (props) => {
    const { label, errorMessage, helperText, value, onChange, ...ckEditorProps } = props;
    const [element, setElement] = useState<HTMLElement | null>(null);
    const { editor, status } = useCKEditor({
        element: element,
        initContent: value,
        dispatchEvent: ({ payload }) => {
            const newData = payload?.editor?.getData();
            if (newData !== undefined) {
                onChange?.(newData);
            }
        },
        subscribeTo: ['change'],
        config: {
            allowedContent: true,
            licenseKey:
                'eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE4MDc5MTk5OTksImp0aSI6IjI3NjBhYmJmLTBhODktNGNiMC1hZTMxLTBhMDA0MDRkMzY2MCIsImxpY2Vuc2VkSG9zdHMiOlsiMTI3LjAuMC4xIiwibG9jYWxob3N0IiwiMTkyLjE2OC4qLioiLCIxMC4qLiouKiIsIjE3Mi4qLiouKiIsIioudGVzdCIsIioubG9jYWxob3N0IiwiKi5sb2NhbCJdLCJ1c2FnZUVuZHBvaW50IjoiaHR0cHM6Ly9wcm94eS1ldmVudC5ja2VkaXRvci5jb20iLCJkaXN0cmlidXRpb25DaGFubmVsIjpbImNsb3VkIiwiZHJ1cGFsIl0sImxpY2Vuc2VUeXBlIjoiZGV2ZWxvcG1lbnQiLCJmZWF0dXJlcyI6WyJEUlVQIiwiRTJQIiwiRTJXIl0sInJlbW92ZUZlYXR1cmVzIjpbIlBCIiwiUkYiLCJTQ0giLCJUQ1AiLCJUTCIsIlRDUiIsIklSIiwiU1VBIiwiQjY0QSIsIkxQIiwiSEUiLCJSRUQiLCJQRk8iLCJXQyIsIkZBUiIsIkJLTSIsIkZQSCIsIk1SRSJdLCJ2YyI6Ijc0ZDgxZGVmIn0.JKiauRE-NKtBG0dPSSSNcnpHeBou9xE37pKW8KIcRYM2cSGfu0zl--b-WBhSDA2LmBz4WVpVt0Gd8_csG8Ze8g',
        },
        ...ckEditorProps,
    });
    useEffect(() => {
        if (editor && editor.getData() !== value && status === 'ready') {
            editor.setData(value);
        }
    }, [value, editor, status]);
    return (
        <InputFieldWrapper label={label} helperText={helperText} errorMessage={errorMessage}>
            <div ref={setElement}></div>
        </InputFieldWrapper>
    );
};
